/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetLeadExchangeDestinationsResponseData } from './GetLeadExchangeDestinationsResponseData';
import {
    GetLeadExchangeDestinationsResponseDataFromJSON,
    GetLeadExchangeDestinationsResponseDataFromJSONTyped,
    GetLeadExchangeDestinationsResponseDataToJSON,
} from './GetLeadExchangeDestinationsResponseData';

/**
 * 
 * @export
 * @interface GetLeadExchangeDestinationsResponse
 */
export interface GetLeadExchangeDestinationsResponse {
    /**
     * 
     * @type {GetLeadExchangeDestinationsResponseData}
     * @memberof GetLeadExchangeDestinationsResponse
     */
    data?: GetLeadExchangeDestinationsResponseData;
}

/**
 * Check if a given object implements the GetLeadExchangeDestinationsResponse interface.
 */
export function instanceOfGetLeadExchangeDestinationsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetLeadExchangeDestinationsResponseFromJSON(json: any): GetLeadExchangeDestinationsResponse {
    return GetLeadExchangeDestinationsResponseFromJSONTyped(json, false);
}

export function GetLeadExchangeDestinationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadExchangeDestinationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : GetLeadExchangeDestinationsResponseDataFromJSON(json['data']),
    };
}

export function GetLeadExchangeDestinationsResponseToJSON(value?: GetLeadExchangeDestinationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetLeadExchangeDestinationsResponseDataToJSON(value.data),
    };
}

